import { TaskTemplateServiceTemplateQuery } from "../../../graphql-types";
import { isLocale } from "../../config/sites-and-locales";
import { PageBaseProps } from "../../shared/components/PageBase";
import { isFixedObject } from "../../shared/types/fixed-object";
import { pp } from "../../shared/utilities/pretty-print";

export function selectPageBaseProps(
  data: TaskTemplateServiceTemplateQuery
): Omit<PageBaseProps, "children"> {
  if (data.taskTemplateServicePage?.canonicalUrl == null) {
    throw Error(
      `data.taskTemplateServicePage?.canonicalUrl is null: ${pp({ data })}`
    );
  }
  if (data.taskTemplateServicePage?.locale == null) {
    throw Error(
      `data.taskTemplateServicePage?.locale is null: ${pp({ data })}`
    );
  }
  if (!isLocale(data.taskTemplateServicePage.locale)) {
    throw Error(`${data.taskTemplateServicePage.locale} is not a valid locale`);
  }
  if (data.taskTemplateServicePage?.noIndexMeta == null) {
    throw Error(
      `data.taskTemplateServicePage?.noIndexMeta is null: ${pp({ data })}`
    );
  }
  const pageImage = data.taskTemplateServicePage.widePhoto?.fixed;
  if (!isFixedObject(pageImage) && pageImage != null) {
    // This will result in a build error, so it won't be shown to users.
    // eslint-disable-next-line no-console
    console.log(pp({ data }));
    throw Error(
      "data.taskTemplateServicePage.widePhoto?.fixed is not a FixedObject or null."
    );
  }

  const {
    canonicalUrl,
    hreflangData,
    locale,
    noIndexMeta,
    pageDescription,
    pageTitle,
    templateName,
  } = data.taskTemplateServicePage;

  return {
    canonicalUrl,
    hreflangData,
    locale,
    noIndexMeta,
    pageDescription,
    pageImage,
    pageTitle,
    serviceType: templateName || "",
  };
}
